import { NgModule }                 from '@angular/core';
import { FormsModule }              from '@angular/forms';
import { CommonModule }             from '@angular/common';
import { DirectivesModule }         from '../directives/directives.module';
import { DebugComponent }           from './debug/debug.component';
import { PipesModule }              from '../pipes/pipes.module';
import { InputboxComponent }        from './inputbox/inputbox.component';
import { VendingProgressComponent } from './_general/vending-progress/vending-progress.component';
import { PageMenuComponent }        from './_general/page-menu/page-menu.component';
import { TerminalComponent }        from './terminal/terminal.component';
import { TurComponentsModule }      from './tur/tur.components.module';
import { CartComponent }            from './_general/cart/cart.component';
import { DialogComponent }          from './dialog/dialog.component';
import { LogoComponent }            from './_general/logo/logo.component';
import { MobileSelectQRComponent } from "./_general/mobileselectqr/mobileselectqr.component";

const COMPONENTS = [
	DebugComponent,
	InputboxComponent,
	PageMenuComponent,
	VendingProgressComponent,
	TerminalComponent,
	CartComponent,
	DialogComponent,
	LogoComponent,
	MobileSelectQRComponent
];

@NgModule({
	imports: [
		FormsModule,
		CommonModule,
		DirectivesModule,
		PipesModule,
		TurComponentsModule

	],
	exports: [...COMPONENTS],
	declarations: [...COMPONENTS]
})
export class ComponentsModule {
}
